<template>
  <div>
    <div class="opage">
      <!-- 资金/交易号汇款 -->
      <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.transactionNumberRemittance')"></baseBreadcrumb>
      <tableTab :val.sync="form.status" :list="tabList" :fun="search">

      </tableTab>
      <div class="button">
        <!-- 抽取金额 -->
        <el-button type="primary" size="small" class="secondary">{{
          $t("message.extractingAmount")
        }}</el-button>
        <!-- 付款 -->
        <el-button type="primary" size="small" @click="payment" v-if="isAuth(325)">{{
          $t("message.payments")
        }}</el-button>
      </div>
      <div class="searchBox">
        <!-- 客户ID -->
        <el-input size="small" :placeholder="$t('message.clientID')" v-model="form.user_id"></el-input>
        <!-- 	客户名 -->
        <el-input size="small" :placeholder="$t('message.customerName')" v-model="form.realname"></el-input>
        <!-- 订单号 -->
        <el-input size="small" :placeholder="$t('message.orderNumber')" v-model="form.order_sn"></el-input>
        <!-- 交易号 -->
        <el-input size="small" :placeholder="$t('message.transactionNumber')" v-model="form.purchase_no"></el-input>
        <el-date-picker size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange" range-separator="-" v-model="value" :default-time="['00:00:00', '23:59:59']"
          :start-placeholder="$t('message.startTime')" :end-placeholder="$t('message.endTime')">
        </el-date-picker>
        <!-- 	全部采购-->
        <el-select size="small" v-model="form.g_id" :placeholder="$t('message.fullPurchase')" filterable clearable>
          <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
        <!-- 	链接列表 -->
        <el-select size="small" v-model="form.type" :placeholder="$t('message.linkedList')">
          <el-option v-for="item in typeOption" :key="item.name" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
        <div class="btns">
          <!-- 筛选 -->
          <el-button size="small" type="primary" @click="search">{{
            $t("message.filter")
          }}</el-button>
          <!-- 重置 -->
          <!-- <el-button size="small">{{ $t("message.reset") }}</el-button> -->
        </div>
      </div>
      <div style="padding: 0 20px">
        <el-table class="tableMy" :data="tableData"
          :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
            'text-align': 'center',
            background: '#f8f8f8',
          }" @selection-change="handleSelectionChange">
          <el-table-column type="index" width="50" label="No">
          </el-table-column>
          <el-table-column type="selection" width="55">
            <template slot-scope="scope">
              <el-popover placement="right" title="合计" width="200" trigger="focus">
                <statistics :checkedList="multipleSelection" />
                <el-checkbox v-model="scope.row.checked" slot="reference" @change="changeChecked"></el-checkbox>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 标识待付款时间 -->
          <el-table-column property="purchase_at" :label="$t('message.identifyTheTimeToBePaid')"
            width="100"></el-table-column>
          <!-- 财务付款时间 -->
          <el-table-column property="pay_at" :label="$t('message.financialPaymentPime')" width="100"></el-table-column>
          <!-- 链接类别 -->
          <el-table-column property="date" :label="$t('message.categoryOfLinks')"
            prop="from_platform"></el-table-column>
          <!-- 交易号 -->
          <el-table-column property="purchase_no" :label="$t('message.transactionNumber')"></el-table-column>
          <!-- 订单号 -->
          <el-table-column property="order_sn" :label="$t('message.orderNumber')">
            <template slot-scope="scope">
              <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" class="a-link" target="_blank">
                {{ scope.row.order_sn }}
              </router-link>
            </template>
          </el-table-column>
          <!-- 番号 -->
          <el-table-column property="sorting" :label="$t('message.mash')"></el-table-column>
          <!-- 购买账户  -->
          <el-table-column property="date" :label="$t('message.purchaseAnAccount')" prop="g_realname"></el-table-column>
          <!-- 采购数据 -->
          <el-table-column property="date" :label="$t('message.purchasingData')">
            <template slot-scope="scope">
              <div>
                <!-- 商品数量 -->
                <p>
                  {{ $t("message.numberOfProducts") }}:{{ scope.row.totalNum }}
                </p>
                <!-- 商品金额 -->
                <p>
                  {{ $t("message.goodsAmount") }}:{{
                    scope.row.totalGoodsPrice
                  }}
                </p>
                <!-- 国内运费 -->
                <p>
                  {{ $t("message.domesticFreight") }}:{{
                    scope.row.totalFreightPrice
                  }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 应付款 -->
          <el-table-column property="shouldPay" :label="$t('message.accountsPayable')"></el-table-column>
          <!-- 客户付款 -->
          <el-table-column property="clientTotal" :label="$t('message.customerPayment')"></el-table-column>
          <!-- 百分比 -->
          <el-table-column property="profits_rate" :label="$t('message.percentage')">
            <template slot-scope="scope">
              <div>{{ scope.row.profits_rate }}%</div>
            </template></el-table-column>
          <!-- 抽取金额 + '暂无'-->
          <!-- <el-table-column property="date" :label="$t('message.extractingAmount')"></el-table-column> -->
          <!-- 财务审核备注-->
          <el-table-column property="date" :label="$t('message.financialAuditRemarks')">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.purchaseRemarkList" :key="index">
                {{ item }}
              </p>
            </template>
          </el-table-column>
          <!-- 付款状态 -->
          <el-table-column property="date" :label="$t('message.paymentStatus')" prop="statusName">
            <!-- 待财务付款 --> <!-- 财务已付款 -->
            <template slot-scope="scope">
              <div>
                <span style="color: #2c96e7">{{
                  scope.row.statusName
                }}</span>
                <!-- <span style="color: #2c96e7" v-if="scope.row.status == 3">{{
                  $t("message.theFinancialDepartmentHasPaid")
                }}</span> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import tableTab from "../components/tableTab.vue";
import { mapState } from "vuex";
import statistics from './statistics.vue'
import { getCurrentTime } from '@/utlis/date'
export default {
  data() {
    return {
      tabList: [
        // 全部汇款
        { name: this.$t("message.allOfTheRemittance"), value: "" },
        // 待付款
        { name: this.$t("message.toBePayment"), value: "2" },
        // 已付款
        { name: this.$t("message.payment"), value: "3" },
      ], //tab列表

      activeName: "",
      value: [
        getCurrentTime(-30) + ' 00:00:00',
        getCurrentTime(0) + ' 23:59:59',
      ],
      form: {},
      total: 0,
      loading: null,
      tableData: [],
      multipleSelection: [], //已选中汇款单子
      BillMethod: [], //支付方式列表
      typeOption: [
        { name: '1688', },
        { name: 'taobao', },
        { name: '自营', },
      ],
    };
  },
  components: { tableTab, statistics },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g
    }

  },
  mounted() {
    this.getData();
    this.purchaseWaitPayListNum()
  },
  methods: {
    purchaseWaitPayListNum() {
      this.$api.tabTotalApi.purchaseWaitPayListNum().then(res => {
        this.tabList[1].name = this.$t("message.toBePayment") + `(${res.data[1].num})`
      })
    },
    // 获取数据
    getData() {
      if (!this.value || this.value.length == 0) {
        this.form.dateStart = null;
        this.form.dateEnd = null;
      } else {
        this.form.dateStart = this.value[0];
        this.form.dateEnd = this.value[1];
      }
      this.$api.financialApi.billPurchaseWaitPayList(this.form).then((res) => {
        // console.log("事件名", res.data.data);
        if (res.code != 0) return this.$message.error(res.msg);
        // 接下来的操作
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data;
        this.total = res.data.total
      });
    },
    // 表格多选框选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.tableData.forEach(items => {
        items.checked = false
      })
      this.multipleSelection.forEach(item => {
        this.tableData.forEach(items => {
          if (item.purchase_no == items.purchase_no) {
            items.checked = true
          }
        })
      })
    },
    // 选择
    changeChecked() {
      this.multipleSelection = []
      this.tableData.forEach(items => {
        if (items.checked) {
          this.multipleSelection.push(items)
        }
      })
    },
    handleSizeChange(val) {

      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {

      this.form.page = val;
      this.getData();
    },
    // 搜索
    search() {
      this.form.page = 1;
      this.getData();
    },
    //付款
    payment() {
      let ids = [];
      for (var i in this.multipleSelection) {
        if (this.multipleSelection[i].status != 3) {
          ids.push(this.multipleSelection[i].purchase_no);
        }
      }
      if (ids.length == 0) {
        // 请选择汇款订单
        return this.$message.warning(
          this.$t("message.pleaseSelectRemittanceOrder")
        );
      }
      this.$confirm(
        this.$t("message.confirmWhetherToRemitTheSelectedOrder"),
        this.$t("message.hint"),
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api.financialApi
            .billPurchaseWaitPayConfirm({ purchaseNoSet: ids })
            .then((res) => {
              ////console.log('事件名',res)
              if (res.code != 0) return this.$message.error(res.msg);
              this.getData();
              this.purchaseWaitPayListNum()
            });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.routerView {
  height: 100%;
}

.opage {
  background-color: #f8f8f8;
  height: 100%;
  position: relative;

  .button {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

.searchBox {
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 160px;
    margin-right: 20px;
  }

  .el-date-editor {
    flex: 0 0 389px;
  }

  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    .el-button {
      min-width: 64px;
      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}

.editForm {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px 24px 1px;

  .el-select {
    width: 100%;
  }

  .imgUp {
    display: flex;
    align-items: flex-start;

    /deep/.avatar-uploader .el-upload {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: white;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    /deep/.el-image {
      width: 80px !important;
      height: 80px !important;
    }

    /deep/.imgBox {
      height: 80px;
    }
  }

  textarea {
    width: 245px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #edeff4;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    padding: 12px 16px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
<style lang="scss">
.zdyPopver {
  padding: 0;

  .el-popover__title {
    padding: 13px 16px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    margin-bottom: 0;
  }

  .popper__arrow {
    display: none;
  }
}

.xianShiLXXX {
  padding: 16px;

  p {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>